import React from 'react';
import styled from 'styled-components';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Logo } from '/imports/ui/Logo';
import { termsHtml } from '/imports/ui/terms';

export const TermsPageStyled = styled(SignedOutPageStyled)`
  .wrapper {
    width: 55rem;
    max-width: 90%;
  }
  .logo img {
    margin-top: 2rem;
  }
`;

/**
 * Public terms-of-service page rendering the terms HTML.
 */
export const TermsPage = () => {
  return (
    <TermsPageStyled className="page">
      <div className="wrapper">
        <div><Logo size={3} /></div>
        <div dangerouslySetInnerHTML={{__html: termsHtml}} />
      </div>
      <PublicFooter />
    </TermsPageStyled>
  );
};